import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { isFlatScalarObject } from "../detect";
import { humanizeKey } from "../humanize";
import { PRIORITY, type RenderContext, type ValueRenderer } from "../types";
import { RegistryValue } from "./RegistryValue";

export const StatGroupRenderer: ValueRenderer = {
  id: "stat-group",
  match: value => (isFlatScalarObject(value) ? { priority: PRIORITY.STRUCTURAL, confidence: "low" } : null),
  Component: ({ value, ctx }) => {
    const obj = value as Record<string, unknown>;
    return (
      <Table className="text-xs">
        <TableBody>
          {Object.entries(obj).map(([key, val]) => {
            const childCtx: RenderContext = {
              ...ctx,
              key,
              parent: obj,
              path: [...ctx.path, key],
              depth: ctx.depth + 1,
            };
            return (
              <TableRow key={key}>
                <TableCell className="text-ds-text-muted w-px whitespace-nowrap align-top font-medium">
                  {humanizeKey(key)}
                </TableCell>
                <TableCell className="align-top">
                  <RegistryValue value={val} ctx={childCtx} />
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    );
  },
};
